export const categoriesTree = {
  ELECTRONICS: [
    "COMPUTERS",
    "MONITORS",
    "PHONES",
    "TABLETS",
    "AUDIO",
    "PROJECTORS",
    "PRINTERS",
    "STORAGES",
    "PC_ACCESSORIES",
    "NAVIGATORS",
    "BATTERIES",
  ],
  STATIONERY: [
    "PAPER",
    "OFFICE_EQUIPMENT",
    "EXERCISE_BOOK",
    "NOTEBOOKS",
    "DIARIES",
    "NOTES",
    "SKETCHBOOKS",
    "FOLDERS",
    "WRITING_UTENSILS",
    "PAPER_SETS",
  ],
  TEXTBOOKS: [
    "CLASS_BOOK_1",
    "CLASS_BOOK_2",
    "CLASS_BOOK_3",
    "CLASS_BOOK_4",
    "CLASS_BOOK_5",
    "CLASS_BOOK_6",
    "CLASS_BOOK_7",
    "CLASS_BOOK_8",
    "CLASS_BOOK_9",
    "CLASS_BOOK_10",
    "CLASS_BOOK_11",
    "CLASS_BOOK_12",
  ],
  CLOTHING_FORM: ["SETS_4_BOYS", "SETS_4_GIRLS"],
  FURNITURE: ["TABLES", "CHAIRS"],
  FOR_VEHICLES: [
    "AUTOPARTS",
    "HEATING_AND_VENTILATION",
    "FILTERS",
    "TRANSMISSION",
    "CAR_BATTERIES",
    "ELECTRICIAN",
    "GLASS",
    "SEATS",
    "AUTOCOSMETICS",
  ],
  ACCESSORIES: ["BACKPACKS", "PENCIL_CASES", "LUNCH_BOXES", "INTERIOR", "USEFUL_THINGS"],
  STUDENTS_PRODUCT: ["STUDENTS_CRAFTS", "SCHOOL_ART", "OTHER"],
}
